<div class="row">
  <div class="col-sm-12">
    <span class="title" translate>
      <fa-icon [icon]="['fas', 'file-upload']" ></fa-icon>
      &nbsp; {{ 'upload_file'| translate }}
    </span>

    <span class="buttons d-flex d-flex-gap">
      <button (click)="onSubmit()" class="btn btn-primary" [ngClass]="(bShowLoader['submit'])? 'btn-spinner' : ''">
        <fa-icon *ngIf="!bShowLoader['submit']" [icon]="['fas', 'file-upload']"></fa-icon>
        <fa-icon *ngIf="bShowLoader['submit']" [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon>
        <span class="pl-1">{{ 'upload' | translate }}</span>
      </button>

      <fieldmagic-primary-button
        (click)="cancelDialog()"
        icon="times"
        variant="error"
        label="close"
      ></fieldmagic-primary-button>
    </span>
  </div>
</div>

<hr class="separator"/>

<span class="label"> {{ 'file' | translate }} </span>
<div class="file-drop-container">
    <input class="file-input" type="file" multiple (change)="onFileChange($event)" />

    <div *ngIf="!isFileDropped && arFiles.length === 0" class="file-input-overlay">
        {{ 'insert_file' | translate }}
    </div>

    <div *ngIf="isFileDropped" class="file-input-overlay-uploading">
        <fa-icon [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon> {{ 'uploading' | translate }}
    </div>

    <div *ngIf="!isFileDropped && arFiles.length > 0" class="file-input-overlay-uploaded">
      {{ arFiles.length }} file(s) selected
    </div>

</div>

<span class="label"> {{ 'description' | translate }} </span>
<div class="description-containter">
  <textarea [required] class="form-control texts"  rows="3" [(ngModel)]="strDescription" (ngModelChange)="markAsEdited()"></textarea>
</div>

<div class="mt-2"
  *ngIf="moduleName === 'jobs'"
>
  <fieldmagic-checkbox-input
    [(ngModel)]="includeInJobReport"
    label="Include in Job Report"
    tooltip="This will only work for photos/images."
  ></fieldmagic-checkbox-input>
</div>